import axios from "axios";

const BASE_URL_AUTH = import.meta.env.VITE_API_AUTH_URL;

const axiosAuthInstance = axios.create({
    baseURL: BASE_URL_AUTH
});

const setAuthToken = (token: string | null) => {
    if (token) {
        axiosAuthInstance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    } else {
        delete axiosAuthInstance.defaults.headers.common['Authorization'];
    }
};

export {
    axiosAuthInstance,
    setAuthToken
}